import Input from './Input.jsx';
import './Input.css';

export default Input;
